/*
* AbstractPdfSection.js
* Created on 22-11-2017
* @author Olivier for &ranj
*/

import { isNull } from "../../util/TypeUtil";
import PdfPageBreakContent from "../content/generic/PdfPageBreakContent";
import PdfTextContent from "../content/generic/PdfTextContent";

export default class AbstractPdfSection {
    constructor(width) {
        this._content = []; //array containing all of the section's content, ordered from top to bottom

        this._height = 0;
        this._width = width;
    }

    initialize() { }; //override in child class to define content of pdf section

    getHeight() {
        return this._height;
    }

    getWidth() {
        return this._height;
    }

    addContent(content) {
        this._content.push(content);
        content.parent = this;
    }

    getContent() {
        return this._content;
    }

    addText(text, style) {
        if (isNull(style.width)) {
            style.width = this._width;
        }

        const pdfText = new PdfTextContent(text, style);
        this.addContent(pdfText);

        return pdfText;
    }

    //adds a page break. Hard page breaks force the document to continue printing on a new page. Soft page breaks only break the page if the content batch that comes after it doesn't fit on the current page
    addPageBreak(isHardBreak) {
        const type = isHardBreak ? PdfPageBreakContent.TYPE_HARD : PdfPageBreakContent.TYPE_SOFT;
        this.addContent(new PdfPageBreakContent(type));
    }

    calculateHeight(doc) {
        let height = 0;

        for (let i = 0; i < this._content.length; i++) {
            this._content[i].calculateBounds(doc);
            height += this._content[i].getFullHeight();
        }

        this._height = height;
    }

    /**
     * Outputs the pdf section's content onto the document
     * @param {*} doc 
     * @param {number} x 
     * @param {number} y 
     */
    printToDocument(doc, x, y) {
        for (let i = 0; i < this._content.length; i++) {
            const content = this._content[i];
            content.printToDocument(doc, x, y);

            y += content.getFullHeight();
        }
    }
}